import React, { useMemo } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { MaterialReactTable } from "material-react-table";

const AttributeList = ({ values }) => {
  const attributes = values?.attributes || [];

  const formatTimeToAMPM = (time) => {
    if (!time) return "";

    const [hours, minutes] = String(time).split(":");
    const hour = Number(hours);

    if (Number.isNaN(hour) || !minutes) {
      return time;
    }

    const period = hour >= 12 ? "PM" : "AM";
    const formattedHour = hour % 12 || 12;

    return `${String(formattedHour).padStart(2, "0")}:${minutes} ${period}`;
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "attributeName",
        header: "Attribute Name",
        Cell: ({ cell }) => cell.getValue() || "-",
      },
      {
        accessorKey: "attributeValue",
        header: "Attribute Value",
        Cell: ({ cell, row }) => {
          const value = cell.getValue();
          const attributeName = row.original?.attributeName;

          // Convert Opening Time / Closing Time to AM/PM format
          if (
            (attributeName === "Opening Time" ||
              attributeName === "Closing Time") &&
            value
          ) {
            return formatTimeToAMPM(value);
          }

          // Handle array values
          if (Array.isArray(value)) {
            return value.length > 0 ? value.join(", ") : "-";
          }

          return value || "-";
        },
      },
    ],
    [],
  );

  return (
    <Container fluid className="py-3">
      <Row>
        <Col lg={12}>
          <Card className="border-0 shadow-sm">
            <CardBody className="p-0">
              <div className="listingjs-table" id="attributeList">
                <div className="container-fluid px-0">
                  <div
                    className="disable-margin-card table-responsive table-customer border w-100"
                    style={{ borderRadius: "4px" }}
                  >
                    <MaterialReactTable
                      columns={columns}
                      data={attributes}
                      enableSorting={false}
                      enableColumnFilters={false}
                      enableFilters={false}
                      enableColumnActions={false}
                      enablePagination={false}
                      enableTopToolbar={false}
                      enableBottomToolbar={false}
                      enableColumnOrdering={false}
                      enableColumnDragging={false}
                      enableRowActions={false}
                      enableDensityToggle={false}
                      enableFullScreenToggle={false}
                      enableHiding={false}
                      muiTablePaperProps={{
                        sx: {
                          padding: 0,
                          boxShadow: "none",
                        },
                      }}
                      muiTableHeadCellProps={{
                        sx: {
                          fontFamily: "Inter, sans-serif",
                          fontWeight: 600,
                          fontSize: "14px",
                        },
                      }}
                      muiTableBodyCellProps={{
                        sx: {
                          fontFamily: "Inter, sans-serif",
                          fontSize: "14px",
                        },
                      }}
                      defaultColumn={{
                        maxSize: 9001,
                        muiTableBodyCellProps: {
                          sx: {
                            fontFamily: "Inter, sans-serif",
                          },
                        },
                        muiTableHeadCellProps: {
                          sx: {
                            fontFamily: "Inter, sans-serif",
                          },
                        },
                      }}
                      layoutMode="grid"
                    />
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AttributeList;